<template>
  <li class="dropdown messages-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
      <i class="fa fa-flag-o"></i>
      <span class="label label-info" v-show="headerNotiApprove.total > 0">{{ numberFormat(headerNotiApprove.total) }}</span>
    </a>
    <ul class="dropdown-menu">
      <li class="noti-header">
        <template v-if="headerNotiApprove.total > 0">
          {{ labels[nowLang]['new_request1'] }} {{ numberFormat(headerNotiApprove.total) }} {{ labels[nowLang]['new_request2'] }}
        </template>
        <template v-else>
          {{ labels[nowLang]['no_request'] }}
        </template>
        </li>
      <li>
        <!-- inner menu: contains the actual data -->
        <ul class="approve-list">
          <li v-for="headerApp in headerNotiApprove.rows">
            <div class="pull-left approve-box">
              <router-link :to="{ name: headerApp.key }">
                <div class="approve-icon-box">
                  <i class="fa fa-flag-o"></i>
                </div>
                <div class="approve-topic-box clearfix">
                  <div class="approve-topic">{{ headerApp.values }}</div>
                  <div class="approve-detail-box" v-if="headerApp.summary == 1" >{{ headerApp.summary }} {{ labels[nowLang]['new_request3'] }}</div>
                  <div class="approve-detail-box" v-else-if="headerApp.summary > 1 && headerApp.summary <= 999" >{{ headerApp.summary }} {{ labels[nowLang]['new_request4'] }}</div>
                  <div class="approve-detail-box" v-else>999+ {{ labels[nowLang]['new_request4'] }}</div>
                </div>
              </router-link>
            </div>
          </li>
        </ul>
      </li>
      <li class="footer">
        <router-link :to="{ name: 'managerapprove' }">
          {{ labels[nowLang]['view_all'] }}
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'header-request',
  props: [ 'headerNotiApprove', 'numberFormat', 'nowLang' ],
  data () {
    return {
      labels: {
        en: {
          'no_request': 'You have no new notification.',
          'new_request1': 'You have',
          'new_request2': 'requests waiting your approval.',
          'view_all': 'View all requests.',
          'new_request3': 'request',
          'new_request4': 'requests'
        },
        th: {
          'no_request': 'คุณไม่มีรายการคำร้องที่ต้องอนุมัติ',
          'new_request1': 'คุณมีรายการคำร้องที่ต้องอนุมัติ',
          'new_request2': 'รายการ',
          'view_all': 'ดูรายการทั้งหมด',
          'new_request3': 'รายการ',
          'new_request4': 'รายการ'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HeaderApprove.vue?773830d7